import styled from "styled-components";

export const Card = styled.div`
  background: white;
  border-radius: 1.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: ${(props) => (props.$noPadding ? "0" : "2rem")};
  width: ${(props) => (props.$fullWidth ? "100%" : "auto")};
`;

export const CardTitle = styled.h2`
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  font-weight: bold;
  text-align: ${(props) => (props.$center ? "center" : "left")};
`;
